import React from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";

const LANGUAGES = [
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" }
];

export default function LanguageSelector({ value, onChange }) {
  const { i18n } = useTranslation();
  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value);
    if (onChange) onChange(e.target.value);
  };
  return (
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel id="lang-select-label">Langue</InputLabel>
      <Select
        labelId="lang-select-label"
        value={i18n.language}
        label="Langue"
        onChange={handleChange}
      >
        {LANGUAGES.map(l => (
          <MenuItem value={l.code} key={l.code}>{l.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
